import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.5 18.75c-.345 .09 -.727 .25 -1.1 .25a4.3 4.3 0 0 1 -1.57 -.298l-3.83 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.335 5.335 0 0 1 9.194 1.078a5.333 5.333 0 0 1 4.484 6.778","key":"svg-0"}],["path",{"d":"M22 22l-5 -5","key":"svg-1"}],["path",{"d":"M17 22l5 -5","key":"svg-2"}]]

const IconBubbleX = createReactComponent('outline', 'bubble-x', 'BubbleX', __iconNode);

export default IconBubbleX;